module.exports = __webpack_public_path__ + "img/ico-posting.c170d721.svg";